import React from 'react';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { FaHeart } from 'react-icons/fa';
import { formatDate } from '@/utils/helpers';

export interface InstagramPost {
  id: string;
  media_type: 'IMAGE' | 'VIDEO';
  media_url: string;
  permalink: string;
  like_count: number;
  caption: string;
  timestamp: string;
}

interface PostsProps {
  posts: InstagramPost[];
}

const RecentPosts: React.FC<PostsProps> = ({ posts }) => {
  const getShortCaption = (caption: string) => {
    const firstSentence = caption.split(/[.!?\n]/)[0];
    return firstSentence.length > 60
      ? firstSentence.substring(0, 60) + '...'
      : firstSentence;
  };

  return (
    <div className="w-full">
      <h2 className="text-2xl font-bold mb-6">Recent Posts</h2>
      <div className="space-y-4 ">
        {posts.map((post) => (
          <div key={post.id}>
            <div className="relative group">
              <a
                href={post.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-4 p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200"
              >
                {/* Thumbnail/Video Container */}
                <div className="relative w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                  {post.media_type === 'VIDEO' ? (
                    <iframe
                      src={post.media_url}
                      className="w-full h-full object-cover"
                      allow=" ; encrypted-media"
                      allowFullScreen
                      loading="lazy"
                    />
                  ) : (
                    /* eslint-disable-next-line @next/next/no-img-element */
                    <img
                      src={post.media_url}
                      alt={getShortCaption(post.caption)}
                      className="w-full h-full object-cover"
                    />
                  )}

                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center space-x-4">
                    <div className="flex items-center text-white">
                      <FaHeart size={14} className="mr-1 text-crunchies-red" />
                      <span className="text-sm">{post.like_count}</span>
                    </div>
                    <HiOutlineExternalLink size={16} className="text-white" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-grow min-w-0">
                  <p className="text-sm text-gray-600">
                    {formatDate(post.timestamp)}
                  </p>
                  <h3 className="text-base font-semibold line-clamp-2">
                    {getShortCaption(post.caption)}
                  </h3>
                </div>
              </a>
            </div>
            <hr className="w-full " />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentPosts;
